export enum WalletType {
  Master = 'master',
  Card = 'card',
  Crypto = 'crypto',
}
